/** 处理拖拽事件 */
globalThis.createDragController = function (options) {
    const {
        el,
        shouldStart,
        onStart,
        onMove,
        onEnd,
        onCancel
    } = options

    let isDragging = false
    let startX = 0
    let startY = 0
    let startTime = 0

    let activePointerId = null
    let didStart = false

    let lockDirection = null // null | 'x' | 'y'
    let isClickPrevented = false

    const THRESHOLD = 5
    const CLICK_THRESHOLD = 5

    const handlePointerDown = (evt) => {
        if (isDragging) return
        if (evt.isPrimary === false) return
        if (evt.pointerType === 'mouse' && evt.button !== 0) return
        if (shouldStart && !shouldStart(evt)) return

        isDragging = true
        didStart = false
        lockDirection = null
        isClickPrevented = false

        startX = evt.clientX
        startY = evt.clientY
        startTime = performance.now()

        activePointerId = evt.pointerId
    }

    const handlePointerMove = (evt) => {
        if (!isDragging || evt.pointerId !== activePointerId) return

        const dx = evt.clientX - startX
        const dy = evt.clientY - startY

        // 判断方向
        if (!lockDirection) {
            if (Math.abs(dx) < THRESHOLD && Math.abs(dy) < THRESHOLD) {
                return
            }

            lockDirection = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'

            if (lockDirection === 'x') {
                try {
                    el.setPointerCapture(activePointerId)
                } catch (e) { }

                didStart = true
                onStart?.({
                    evt,
                    startX,
                    startY
                })
            }

            return
        }

        // 纵向直接放行
        if (lockDirection === 'y') return

        // 横向拖拽 → 阻止默认
        evt.preventDefault()

        if (Math.abs(dx) > CLICK_THRESHOLD) {
            isClickPrevented = true
        }

        onMove?.({
            evt,
            dx,
            dy,
            startX,
            startY
        })
    }

    const handlePointerUp = (evt) => {
        if (!isDragging || evt.pointerId !== activePointerId) return

        if (lockDirection !== 'x') {
            cleanup({ evt })
            return
        }

        const dx = evt.clientX - startX
        const dy = evt.clientY - startY
        const dt = performance.now() - startTime
        const velocity = dx / dt

        finish({
            evt,
            dx,
            dy,
            dt,
            velocity,
            cancelled: false
        })
    }

    const handlePointerCancel = (evt) => {
        if (evt.pointerId !== activePointerId) return
        finish({ evt, cancelled: true })
    }

    const handleLostPointerCapture = (evt) => {
        if (!isDragging || evt.pointerId !== activePointerId) return
        finish({ evt, cancelled: true })
    }

    const handleClickCapture = (evt) => {
        if (!isClickPrevented) return

        evt.preventDefault()
        evt.stopPropagation()
    }

    const finish = (detail = {}) => {
        if (!isDragging) return

        const pointerId = activePointerId
        const shouldNotify = didStart && lockDirection === 'x'

        isDragging = false
        didStart = false
        activePointerId = null
        lockDirection = null

        if (pointerId != null && el.hasPointerCapture?.(pointerId)) {
            try {
                el.releasePointerCapture(pointerId)
            } catch (e) { }
        }

        if (!shouldNotify) return

        if (detail.cancelled) {
            onCancel?.(detail)
        } else {
            onEnd?.(detail)
        }
    }

    const cleanup = (detail = {}) => {
        finish({
            ...detail,
            cancelled: true
        })
    }

    const register = () => {
        el.addEventListener('pointerdown', handlePointerDown, { passive: true })
        window.addEventListener('pointermove', handlePointerMove, { passive: false })
        window.addEventListener('pointerup', handlePointerUp)
        window.addEventListener('pointercancel', handlePointerCancel)
        el.addEventListener('lostpointercapture', handleLostPointerCapture)

        el.addEventListener('click', handleClickCapture, true)
    }

    const unregister = () => {
        cleanup()

        el.removeEventListener('pointerdown', handlePointerDown)
        window.removeEventListener('pointermove', handlePointerMove)
        window.removeEventListener('pointerup', handlePointerUp)
        window.removeEventListener('pointercancel', handlePointerCancel)
        el.removeEventListener('lostpointercapture', handleLostPointerCapture)

        el.removeEventListener('click', handleClickCapture, true)
    }

    return {
        register,
        unregister,
        cleanup,
        get isDragging() {
            return isDragging && lockDirection === 'x'
        }
    }
}
